import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { updateContextOperation } from '../state/modules/aiAssistant/operations';

const useAIContext = () => {
  const location = useLocation();
  const params = useParams();
  const dispatch = useDispatch();

  const storeSettings = useSelector(state => state.store?.settings);
  const courseSettings = useSelector(state => state.edit?.settings);
  const courseMaterial = useSelector(state => state.edit?.courseMaterial);
  const userData = useSelector(state => state.common?.authUser);

  useEffect(() => {
    const detectContext = () => {
      const path = location.pathname;

      if (path.includes('/admin/store')) {
        return {
          pageType: 'store',
          pageId: storeSettings?.id,
          pageTitle: 'Store Settings',
          data: {
            brandName: storeSettings?.store_brand_name,
            tagline: storeSettings?.store_tagline,
            about: storeSettings?.store_about_text,
          }
        };
      }

      if (path.includes('/admin/programs/edit') || path.includes('/admin/courses/edit')) {
        return {
          pageType: 'course',
          pageId: params.id || courseSettings?.id,
          pageTitle: courseSettings?.title || 'Course Editor',
          data: {
            courseTitle: courseSettings?.title,
            sections: courseMaterial?.sections,
          }
        };
      }

      if (path.includes('/admin/dashboard')) {
        return {
          pageType: 'dashboard',
          pageId: null,
          pageTitle: 'Dashboard',
          data: {
            userName: userData?.name,
            role: userData?.role
          }
        };
      }

      if (path.includes('/admin/programs') || path.includes('/admin/courses')) {
        return {
          pageType: 'courses',
          pageId: null,
          pageTitle: 'Courses',
          data: {}
        };
      }

      if (path.includes('/admin/members')) {
        return {
          pageType: 'members',
          pageId: null,
          pageTitle: 'Members',
          data: {}
        };
      }

      return {
        pageType: 'general',
        pageId: null,
        pageTitle: document.title || 'Admin',
        data: {
          path,
          url: window.location.href
        }
      };
    };

    const context = detectContext();
    dispatch(updateContextOperation(context));
  }, [location, params, storeSettings, courseSettings, courseMaterial, userData, dispatch]);

  return null;
};

export default useAIContext;
